import React from 'react';
import { AiOutlineStop } from 'react-icons/ai';

const DeclineBox = () => {
    return (
        <div
            style={{
                width: '450px',
                height: '60px',
                borderRadius: '15px',
                backgroundColor: "#FF4C4C",
                color: "white",
                opacity: '0.9',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginLeft: 20,
                marginRight: 20,
                padding: '0 10px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                cursor: "not-allowed"
            }}
            className={"slide-in-input"}
        >
            <AiOutlineStop size={24} style={{ marginRight: 10 }} />
            <p style={{ textAlign: 'center', margin: 0, fontFamily: "FiraGO-SemiBold", fontSize: '16px' }}>
                წარმოების ვადის ათვლა შეჩერებულია
            </p>
        </div>
    );
};

export default DeclineBox;
